<template>
  <div class="card-form">
    <div>
      <SummaryTable></SummaryTable>
    </div>

    <div>
      <OperationalTable></OperationalTable>
    </div>
  </div>
</template>
<script>
import SummaryTable from '../summary-table'
import OperationalTable from '../operational-table'
export default {
      components: { SummaryTable, OperationalTable },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.title {
  font-size: 14px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
